<template>
  <div class="container col-md-12">
    <h1>Contribution calculator</h1>
    <roe-calc-input-fields
      :inputCategories="inputCategories"
      :calcAction="calcAction"
    >
    </roe-calc-input-fields>

    <div v-if="calcData">
      <hr />
      <h3>Result</h3>
      <md-content>
        <md-tabs>
          <md-tab md-label="Staging Area">
            <md-content class="md-padding">
              <table class="table table-striped table-bordered">
                <tr>
                  <th>#</th>
                  <th>Step Description</th>
                  <th>Sample Data</th>
                </tr>
                <tr>
                  <td
                      colspan="4"
                      scope="colgroup"
                      style="background-color: black; color:white"
                  >
                    Obtain Date of Birth and Calculate Various Retirement Dates
                  </td>
                </tr>
                <tr>
                  <td>1.01</td>
                  <td>Get Date of Birth</td>
                  <td>
                    {{
                    calcData.participant.birth_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("MM/D/YYYY")
                    }}
                  </td>
                </tr>
                <tr>
                  <td>1.02</td>
                  <td>Calculate Normal Retirement Date (NRD)</td>
                  <td>
                    {{
                    calcData.retirement_dates.nrd
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("MM/D/YYYY")
                    }}
                  </td>
                </tr>
                <tr>
                  <td>1.03</td>
                  <td>Calculate NRD in months</td>
                  <td>{{ calcData.retirement_dates.nrd_in_months }}</td>
                </tr>
                <tr>
                  <td>1.04</td>
                  <td>Get Desired Retirement Date (DRD)</td>
                  <td>
                    {{
                    calcData.retirement_dates.drd
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("MM/D/YYYY")
                    }}
                  </td>
                </tr>
                <tr>
                  <td>1.05</td>
                  <td>Calculate DRD in months</td>
                  <td>{{ calcData.retirement_dates.drd_in_months }}</td>
                </tr>
                <tr>
                  <td>1.06</td>
                  <td>Calculate age 62 Eligible Retirement Date</td>
                  <td>
                    {{
                    calcData.retirement_dates.age62_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("MM/D/YYYY")
                    }}
                  </td>
                </tr>
                <tr>
                  <td>1.07</td>
                  <td>Calculate age 62 in months</td>
                  <td>{{ calcData.retirement_dates.age62_in_months }}</td>
                </tr>
                <tr>
                  <td>1.08</td>
                  <td>Calculate age 70 Eligible Retirement Date</td>
                  <td>
                    {{
                    calcData.retirement_dates.age70_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("MM/D/YYYY")
                    }}
                  </td>
                </tr>
                <tr>
                  <td>1.09</td>
                  <td>Calculate Age 70 in months</td>
                  <td>{{ calcData.retirement_dates.age70_in_months }}</td>
                </tr>
                <tr>
                  <td>1.10</td>
                  <td>Get Date of Termination</td>
                  <td></td>
                </tr>
                <tr>
                  <td
                      colspan="4"
                      scope="colgroup"
                      style="background-color: black; color:white"
                  >
                    Obtain Current Compensation for EE Contributions and Limit
                    per Law for Employer Contributions
                  </td>
                </tr>
                <tr>
                  <td>2.01</td>
                  <td>Get Annual Compensation</td>
                  <td>
                    {{ calcData.participant.estimated_annual_wages | currency }}
                  </td>
                </tr>
                <tr>
                  <td>2.02</td>
                  <td>Calculate Eligibile Compensation</td>
<!--                  <td>{{ calcData.compensation.eligible | currency }}</td>-->
                </tr>
                <tr>
                  <td
                      colspan="4"
                      scope="colgroup"
                      style="background-color: black; color:white"
                  >
                    Obtain Current Balances
                  </td>
                </tr>
                <tr>
                  <td>3.01</td>
                  <td>Data as of Date</td>
                  <td>
                    {{
                    calcData.plan_basic_data.date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("MM/D/YYYY")
                    }}
                  </td>
                </tr>
                <tr>
                  <td>3.01</td>
                  <td>Plan end date</td>
                  <td>
                    {{
                    calcData.plan_basic_data.plan_end_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("MM/D/YYYY")
                    }}
                  </td>
                </tr>
                <tr>
                  <td>3.02</td>
                  <td>Get Beginning Balance of Pre-Tax source</td>
                  <!--<td>{{ calcData. | currency }}</td>-->
                </tr>
                <tr>
                  <td>3.03</td>
                  <td>Get beginning Balance of Roth Source</td>
                  <!--<td>{{ calcData. | currency }}</td>-->
                </tr>
                <tr>
                  <td>3.04</td>
                  <td>Get beginning Balance of Post-Tax Source</td>
                  <!--<td>{{ calcData. | currency }}</td>-->
                </tr>
                <tr>
                  <td>3.05</td>
                  <td>Get beginning Balance of Rollover Balance</td>
                  <!--<td>{{ calcData. | currency }}</td>-->
                </tr>
                <tr>
                  <td>3.06</td>
                  <td>Get beginning Balance of Employer Match Source</td>
                  <!--<td>{{ calcData. | currency }}</td>-->
                </tr>
                <tr>
                  <td>3.07</td>
                  <td>Get beginning Balance of Employer Other Source</td>
                  <!--<td>{{ calcData. | currency }}</td>-->
                </tr>
                <tr>
                  <td
                      colspan="4"
                      scope="colgroup"
                      style="background-color: black; color:white"
                  >
                    Calculate Employee Contribution Eligibility Dates
                  </td>
                </tr>
                <tr>
                  <td>4.01</td>
                  <td>Date of Birth</td>
                  <td>
                    {{
                    calcData.participant.birth_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("MM/D/YYYY")
                    }}
                  </td>
                </tr>
                <tr>
                  <td>4.02</td>
                  <td>Date of Hire</td>
                  <td>
                    {{
                    calcData.participant.hire_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("MM/D/YYYY")
                    }}
                  </td>
                </tr>
<!--                <tr>-->
<!--                  <td>4.03</td>-->
<!--                  <td>Adjust Date of Birth for Age Requirements</td>-->
<!--                  <td>-->
<!--                    {{-->
<!--                    calcData.ee.adjust_birth_date-->
<!--                    | dateParse("YYYY-MM-DD")-->
<!--                    | dateFormat("MM/D/YYYY")-->
<!--                    }}-->
<!--                  </td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <td>4.04</td>-->
<!--                  <td>Adjust Date of Hire for Service Requirements</td>-->
<!--                  <td>-->
<!--                    {{-->
<!--                    calcData.ee.adjust_hire_date-->
<!--                    | dateParse("YYYY-MM-DD")-->
<!--                    | dateFormat("MM/D/YYYY")-->
<!--                    }}-->
<!--                  </td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <td>4.05</td>-->
<!--                  <td>Later of Age or Service Eligibility Date</td>-->
<!--                  <td>-->
<!--                    {{-->
<!--                    calcData.ee.immediate-->
<!--                    | dateParse("YYYY-MM-DD")-->
<!--                    | dateFormat("MM/D/YYYY")-->
<!--                    }}-->
<!--                  </td>-->
<!--                </tr>-->
                <tr>
                  <td>4.06</td>
                  <td>Adjust for Entry Date</td>
                  <td>
                    {{
                    calcData.adjust_entry_dates.ee
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("MM/D/YYYY")
                    }}
                  </td>
                </tr>
                <tr>
                  <td
                      colspan="4"
                      scope="colgroup"
                      style="background-color: black; color:white"
                  >
                    Calculate Employer Match Eligibility Dates
                  </td>
                </tr>
<!--                <tr>-->
<!--                  <td>4.07</td>-->
<!--                  <td>Adjust Date of Birth for Age Requirements</td>-->
<!--                  <td>-->
<!--                    {{-->
<!--                    calcData.er_match.adjust_birth_date-->
<!--                    | dateParse("YYYY-MM-DD")-->
<!--                    | dateFormat("MM/D/YYYY")-->
<!--                    }}-->
<!--                  </td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <td>4.08</td>-->
<!--                  <td>Adjust Date of Hire for Service Requirements</td>-->
<!--                  <td>-->
<!--                    {{-->
<!--                    calcData.er_match.adjust_hire_date-->
<!--                    | dateParse("YYYY-MM-DD")-->
<!--                    | dateFormat("MM/D/YYYY")-->
<!--                    }}-->
<!--                  </td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <td>4.09</td>-->
<!--                  <td>Later of Age or Service Eligibility Date</td>-->
<!--                  <td>-->
<!--                    {{-->
<!--                    calcData.er_match.immediate-->
<!--                    | dateParse("YYYY-MM-DD")-->
<!--                    | dateFormat("MM/D/YYYY")-->
<!--                    }}-->
<!--                  </td>-->
<!--                </tr>-->
                <tr>
                  <td>4.10</td>
                  <td>Adjust for Entry Date</td>
                  <td>
                    {{
                    calcData.adjust_entry_dates.er_match
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("MM/D/YYYY")
                    }}
                  </td>
                </tr>
                <tr>
                  <td
                      colspan="4"
                      scope="colgroup"
                      style="background-color: black; color:white"
                  >
                    Calculate Employer Match Eligibility Dates
                  </td>
                </tr>
<!--                <tr>-->
<!--                  <td>4.11</td>-->
<!--                  <td>Adjust Date of Birth for Age Requirements</td>-->
<!--                  <td>-->
<!--                    {{-->
<!--                    calcData.er_other.adjust_birth_date-->
<!--                    | dateParse("YYYY-MM-DD")-->
<!--                    | dateFormat("MM/D/YYYY")-->
<!--                    }}-->
<!--                  </td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <td>4.12</td>-->
<!--                  <td>Adjust Date of Hire for Service Requirements</td>-->
<!--                  <td>-->
<!--                    {{-->
<!--                    calcData.er_other.adjust_hire_date-->
<!--                    | dateParse("YYYY-MM-DD")-->
<!--                    | dateFormat("MM/D/YYYY")-->
<!--                    }}-->
<!--                  </td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <td>4.13</td>-->
<!--                  <td>Later of Age or Service Eligibility Date</td>-->
<!--                  <td>-->
<!--                    {{-->
<!--                    calcData.er_other.immediate-->
<!--                    | dateParse("YYYY-MM-DD")-->
<!--                    | dateFormat("MM/D/YYYY")-->
<!--                    }}-->
<!--                  </td>-->
<!--                </tr>-->
                <tr>
                  <td>4.14</td>
                  <td>Adjust for Entry Date</td>
                  <td>
                    {{
                    calcData.adjust_entry_dates.er_other
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("MM/D/YYYY")
                    }}
                  </td>
                </tr>
                <tr>
                  <td
                      colspan="4"
                      scope="colgroup"
                      style="background-color: black; color:white"
                  >
                    Obtain Plan Design Auto Enroll and Auto Escalate Provisions
                  </td>
                </tr>
                <tr>
                  <td>5.01</td>
                  <td>Plan Auto-Enrollment</td>
                  <td>{{ calcData.auto_enrollment.plan }}</td>
                </tr>
                <tr>
                  <td>5.02</td>
                  <td>Plan Auto-Enrollment Initial Percentage</td>
                  <td>
                    {{
                    calcData.auto_enrollment.initial_percent | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>5.03</td>
                  <td>Plan Auto Enrollment Type</td>
                  <td>{{ calcData.auto_enrollment.type }}</td>
                </tr>
                <tr>
                  <td>5.04</td>
                  <td>Plan Auto Increase Type</td>
                  <td>{{ calcData.auto_increase.type }}</td>
                </tr>
                <tr>
                  <td>5.05</td>
                  <td>Plan Auto Increase Source</td>
                  <td>{{ calcData.auto_increase.source }}</td>
                </tr>
                <tr>
                  <td>5.06</td>
                  <td>Plan Auto Increase Annual</td>
                  <td>{{ calcData.auto_increase.annual | numeral("0,0") }}%</td>
                </tr>
                <tr>
                  <td>5.07</td>
                  <td>Plan Auto Increase Max</td>
                  <td>{{ calcData.auto_increase.max | numeral("0,0") }}%</td>
                </tr>
                <tr>
                  <td>5.08</td>
                  <td>Plan Auto Increase Date</td>
                  <td>{{ calcData.auto_increase.date_type }}</td>
                </tr>
                <tr>
                  <td
                      colspan="4"
                      scope="colgroup"
                      style="background-color: black; color:white"
                  >
                    Obtain Pre-Tax Contribution Fields
                  </td>
                </tr>
                <tr>
                  <td>6.01</td>
                  <td>pre_tax_deferral_ytd_dollars</td>
                  <td>
                    {{ calcData.pre_tax_contribution.ytd_dollars | currency }}
                  </td>
                </tr>
                <tr>
                  <td>6.02</td>
                  <td>pre_tax_deferral_percent</td>
                  <td>
                    {{
                    calcData.pre_tax_contribution.percent | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>6.03</td>
                  <td>pre_tax_deferral_dollars</td>
                  <td>
                    {{ calcData.pre_tax_contribution.dollars | currency }}
                  </td>
                </tr>
                <tr>
                  <td>6.04</td>
                  <td>pre_tax_deferral_dollars_frequency</td>
                  <td>{{ calcData.pre_tax_contribution.dollars_frequency }}</td>
                </tr>
                <tr>
                  <td>6.05</td>
                  <td>pre_tax_deferral_ytd_catchup_dollars</td>
                  <td>
                    {{
                    calcData.pre_tax_contribution.ytd_catchup_dollars
                    | currency
                    }}
                  </td>
                </tr>
                <tr>
                  <td>6.06</td>
                  <td>pre_tax_deferral_percent_catchup</td>
                  <td>
                    {{
                    calcData.pre_tax_contribution.percent_catchup
                    | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>6.07</td>
                  <td>pre_tax_deferral_dollars_catchup</td>
                  <td>
                    {{
                    calcData.pre_tax_contribution.dollars_catchup | currency
                    }}
                  </td>
                </tr>
                <tr>
                  <td>6.08</td>
                  <td>pre_tax_deferral_dollars_catchup_frequency</td>
                  <td>
                    {{
                    calcData.pre_tax_contribution.dollars_catchup_frequency
                    }}
                  </td>
                </tr>
                <tr>
                  <td>6.09</td>
                  <td>ee_chosen_auto_enroll_opt_out_pre_tax</td>
                  <td>{{ calcData.pre_tax_contribution.opt_out }}</td>
                </tr>
                <tr>
                  <td>6.10</td>
                  <td>ee_chosen_auto_escalate_frequency_type_pre_tax</td>
                  <td>{{ calcData.pre_tax_contribution.frequency_type }}</td>
                </tr>
                <tr>
                  <td>6.11</td>
                  <td>ee_chosen_auto_escalate_annual_pre_tax_percent</td>
                  <td>
                    {{
                    calcData.pre_tax_contribution.annual_percent
                    | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>6.12</td>
                  <td>ee_chosen_auto_escalate_maximum_pre_tax_percent</td>
                  <td>
                    {{
                    calcData.pre_tax_contribution.maximum_percent
                    | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>6.13</td>
                  <td>ee_chosen_auto_escalate_frequency1_pre_tax</td>
                  <td>{{ calcData.pre_tax_contribution.frequency1 }}</td>
                </tr>
                <tr>
                  <td>6.14</td>
                  <td>ee_chosen_auto_escalate_frequency2_pre_tax</td>
                  <td>{{ calcData.pre_tax_contribution.frequency2 }}</td>
                </tr>
                <tr>
                  <td
                      colspan="4"
                      scope="colgroup"
                      style="background-color: black; color:white"
                  >
                    Obtain Roth Contribution Fields
                  </td>
                </tr>
                <tr>
                  <td>7.01</td>
                  <td>roth_deferral_ytd_dollars</td>
                  <td>
                    {{ calcData.roth_contribution.ytd_dollars | currency }}
                  </td>
                </tr>
                <tr>
                  <td>7.02</td>
                  <td>roth_deferral_percent</td>
                  <td>
                    {{ calcData.roth_contribution.percent | numeral("0,0") }}%
                  </td>
                </tr>
                <tr>
                  <td>7.03</td>
                  <td>roth_deferral_dollars</td>
                  <td>{{ calcData.roth_contribution.dollars | currency }}</td>
                </tr>
                <tr>
                  <td>7.04</td>
                  <td>roth_deferral_dollars_frequency</td>
                  <td>{{ calcData.roth_contribution.dollars_frequency }}</td>
                </tr>
                <tr>
                  <td>7.05</td>
                  <td>roth_deferral_ytd_catchup_dollars</td>
                  <td>
                    {{
                    calcData.roth_contribution.ytd_catchup_dollars | currency
                    }}
                  </td>
                </tr>
                <tr>
                  <td>7.06</td>
                  <td>roth_deferral_percent_catchup</td>
                  <td>
                    {{
                    calcData.roth_contribution.percent_catchup
                    | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>7.07</td>
                  <td>roth_deferral_dollars_catchup</td>
                  <td>
                    {{ calcData.roth_contribution.dollars_catchup | currency }}
                  </td>
                </tr>
                <tr>
                  <td>7.08</td>
                  <td>roth_deferral_dollars_catchup_frequency</td>
                  <td>
                    {{ calcData.roth_contribution.dollars_catchup_frequency }}
                  </td>
                </tr>
                <tr>
                  <td>7.09</td>
                  <td>ee_chosen_auto_enroll_opt_out_roth</td>
                  <td>{{ calcData.roth_contribution.opt_out }}</td>
                </tr>
                <tr>
                  <td>7.10</td>
                  <td>ee_chosen_auto_escalate_frequency_type_roth</td>
                  <td>{{ calcData.roth_contribution.frequency_type }}</td>
                </tr>
                <tr>
                  <td>7.11</td>
                  <td>ee_chosen_auto_escalate_annual_roth_percent</td>
                  <td>
                    {{
                    calcData.roth_contribution.annual_percent
                    | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>7.12</td>
                  <td>ee_chosen_auto_escalate_maximum_roth_percent</td>
                  <td>
                    {{
                    calcData.roth_contribution.maximum_percent
                    | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>7.13</td>
                  <td>ee_chosen_auto_escalate_frequency1_roth</td>
                  <td>{{ calcData.roth_contribution.frequency1 }}</td>
                </tr>
                <tr>
                  <td>7.14</td>
                  <td>ee_chosen_auto_escalate_frequency2_roth</td>
                  <td>{{ calcData.roth_contribution.frequency2 }}</td>
                </tr>
                <tr>
                  <td
                      colspan="4"
                      scope="colgroup"
                      style="background-color: black; color:white"
                  >
                    Obtain Post-Tax Contribution Fields
                  </td>
                </tr>
                <tr>
                  <td>8.01</td>
                  <td>post_tax_deferral_ytd_dollars</td>
                  <td>
                    {{ calcData.post_tax_contribution.ytd_dollars | currency }}
                  </td>
                </tr>
                <tr>
                  <td>8.02</td>
                  <td>post_tax_deferral_percent</td>
                  <td>
                    {{
                    calcData.post_tax_contribution.percent | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>8.03</td>
                  <td>post_tax_deferral_dollars</td>
                  <td>
                    {{ calcData.post_tax_contribution.dollars | currency }}
                  </td>
                </tr>
                <tr>
                  <td>8.04</td>
                  <td>post_tax_deferral_dollars_frequency</td>
                  <td>
                    {{ calcData.post_tax_contribution.dollars_frequency }}
                  </td>
                </tr>
                <tr>
                  <td
                      colspan="4"
                      scope="colgroup"
                      style="background-color: black; color:white"
                  >
                    Obtain Employer Matching Fields
                  </td>
                </tr>
                <tr>
                  <td>9.01</td>
                  <td>ER Match</td>
                  <td>{{ calcData.employer_match.er_match }}</td>
                </tr>
                <tr>
                  <td>9.02</td>
                  <td>ER Match Age requirement Years</td>
                  <td>{{ calcData.employer_match.req_age_years }}</td>
                </tr>
                <tr>
                  <td>9.03</td>
                  <td>ER Match Age requirement Months</td>
                  <td>{{ calcData.employer_match.req_age_months }}</td>
                </tr>
                <tr>
                  <td>9.04</td>
                  <td>ER Match Service requirement Years</td>
                  <td>{{ calcData.employer_match.req_service_years }}</td>
                </tr>
                <tr>
                  <td>9.05</td>
                  <td>ER Match Service requirement Months</td>
                  <td>{{ calcData.employer_match.req_service_months }}</td>
                </tr>
                <tr>
                  <td>9.06</td>
                  <td>ER Matching Type</td>
                  <td>{{ calcData.employer_match.type }}</td>
                </tr>
                <tr>
                  <td>9.07</td>
                  <td>ER Match Vary on YOS</td>
                  <td>{{ calcData.employer_match.yos_vary }}</td>
                </tr>
                <tr>
                  <td>9.08</td>
                  <td>ER Match Number of Tiers</td>
                  <td>{{ calcData.employer_match.tiers.length }}</td>
                </tr>
                <tr>
                  <td>9.09</td>
                  <td>ER Match Tier 1 Matching Amount</td>
                  <td>
                    {{
                    calcData.employer_match.tiers[0].matching_amount
                    | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>9.10</td>
                  <td>ER Match Tier 1 Deferral Rate</td>
                  <td>
                    {{
                    calcData.employer_match.tiers[0].deferral_rate
                    | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>9.11</td>
                  <td>ER Match Tier 1 Contribution Amount</td>
                  <td>
                    {{
                    calcData.employer_match.tiers[0].contribution_amount
                    | currency
                    }}
                  </td>
                </tr>
                <tr>
                  <td>9.12</td>
                  <td>ER Match Tier 1 YOS Upper Limit</td>
                  <td>
                    {{ calcData.employer_match.tiers[0].yos_upper_limit }}
                  </td>
                </tr>
                <tr>
                  <td>9.13</td>
                  <td>ER Match Tier 2 Matching Amount</td>
                  <td>
                    {{
                    calcData.employer_match.tiers[1].matching_amount
                    | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>9.14</td>
                  <td>ER Match Tier 2 Deferral Rate</td>
                  <td>
                    {{
                    calcData.employer_match.tiers[1].deferral_rate
                    | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>9.15</td>
                  <td>ER Match Tier 2 Contribution Amount</td>
                  <td>
                    {{
                    calcData.employer_match.tiers[1].contribution_amount
                    | currency
                    }}
                  </td>
                </tr>
                <tr>
                  <td>9.16</td>
                  <td>ER Match Tier 2 YOS Upper Limit</td>
                  <td>
                    {{ calcData.employer_match.tiers[1].yos_upper_limit }}
                  </td>
                </tr>
                <tr>
                  <td>9.17</td>
                  <td>ER Match Tier 3 Matching Amount</td>
                  <td>
                    {{
                    calcData.employer_match.tiers[2].matching_amount
                    | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>9.18</td>
                  <td>ER Match Tier 3 Deferral Rate</td>
                  <td>
                    {{
                    calcData.employer_match.tiers[2].deferral_rate
                    | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>9.19</td>
                  <td>ER Match Tier 3 Contribution Amount</td>
                  <td>
                    {{
                    calcData.employer_match.tiers[2].contribution_amount
                    | currency
                    }}
                  </td>
                </tr>
                <tr>
                  <td>9.20</td>
                  <td>ER Match Tier 3 YOS Upper Limit</td>
                  <td>
                    {{ calcData.employer_match.tiers[2].yos_upper_limit }}
                  </td>
                </tr>
                <tr>
                  <td>9.21</td>
                  <td>ER Match Tier 4 Matching Amount</td>
                  <td>
                    {{
                    calcData.employer_match.tiers[3].matching_amount
                    | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>9.22</td>
                  <td>ER Match Tier 4 Deferral Rate</td>
                  <td>
                    {{
                    calcData.employer_match.tiers[3].deferral_rate
                    | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>9.23</td>
                  <td>ER Match Tier 4 Contribution Amount</td>
                  <td>
                    {{
                    calcData.employer_match.tiers[3].contribution_amount
                    | currency
                    }}
                  </td>
                </tr>
                <tr>
                  <td>9.24</td>
                  <td>ER Match Tier 4 YOS Upper Limit</td>
                  <td>
                    {{ calcData.employer_match.tiers[3].yos_upper_limit }}
                  </td>
                </tr>
                <tr>
                  <td>9.25</td>
                  <td>ER Match Tier 5 Matching Amount</td>
                  <td>
                    {{
                    calcData.employer_match.tiers[4].matching_amount
                    | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>9.26</td>
                  <td>ER Match Tier 5 Deferral Rate</td>
                  <td>
                    {{
                    calcData.employer_match.tiers[4].deferral_rate
                    | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>9.27</td>
                  <td>ER Match Tier 5 Contribution Amount</td>
                  <td>
                    {{
                    calcData.employer_match.tiers[4].contribution_amount
                    | currency
                    }}
                  </td>
                </tr>
                <tr>
                  <td>9.28</td>
                  <td>ER Match Tier 5 YOS Upper Limit</td>
                  <td>
                    {{ calcData.employer_match.tiers[4].yos_upper_limit }}
                  </td>
                </tr>
                <tr>
                  <td>9.29</td>
                  <td>ER Match Dollar Limit</td>
                  <td>{{ calcData.employer_match.dollar_limit }}</td>
                </tr>
                <tr>
                  <td>9.30</td>
                  <td>ER Match Dollar Limit Amount</td>
                  <td>
                    {{ calcData.employer_match.dollar_limit_amount | currency }}
                  </td>
                </tr>
                <tr>
                  <td>9.31</td>
                  <td>ER Match Catch-Up Contribution Matched</td>
                  <td>{{ calcData.employer_match.catch_up_matched }}</td>
                </tr>
                <tr>
                  <td>9.32</td>
                  <td>ER Match Funding Frequency</td>
                  <td>{{ calcData.employer_match.funding_frequency }}</td>
                </tr>
                <tr>
                  <td>9.33</td>
                  <td>er_matching_contribution_ytd_dollars</td>
                  <!--<td>{{ calcData.employer_other.dollar_limit_amount | currency }}</td>-->
                </tr>
                <tr>
                  <td
                      colspan="4"
                      scope="colgroup"
                      style="background-color: black; color:white"
                  >
                    Obtain Employer Other Fields
                  </td>
                </tr>
                <tr>
                  <td>10.01</td>
                  <td>ER Other</td>
                  <td>{{ calcData.employer_other.er_other }}</td>
                </tr>
                <tr>
                  <td>10.02</td>
                  <td>ER Other Age Requirement Years</td>
                  <td>{{ calcData.employer_other.req_age_years }}</td>
                </tr>
                <tr>
                  <td>10.03</td>
                  <td>ER Other Age Requirement Months</td>
                  <td>{{ calcData.employer_other.req_age_months }}</td>
                </tr>
                <tr>
                  <td>10.04</td>
                  <td>ER Other Service Requirement</td>
                  <td>{{ calcData.employer_other.req_service_years }}</td>
                </tr>
                <tr>
                  <td>10.05</td>
                  <td>ER Other Service Requirement Months</td>
                  <td>{{ calcData.employer_other.req_service_months }}</td>
                </tr>
                <tr>
                  <td>10.06</td>
                  <td>ER Other Percent of Compensation</td>
                  <td>
                    {{
                    calcData.employer_other.compensation_percent
                    | numeral("0,0")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>10.07</td>
                  <td>ER Other Dollar Limit</td>
                  <td>{{ calcData.employer_other.dollar_limit }}</td>
                </tr>
                <tr>
                  <td>10.08</td>
                  <td>ER Other Dollar Limit Amount</td>
                  <td>
                    {{ calcData.employer_other.dollar_limit_amount | currency }}
                  </td>
                </tr>
                <tr>
                  <td>10.09</td>
                  <td>ER Other Flat Dollar Amount</td>
                  <td>
                    {{ calcData.employer_other.flat_dollar_limit | currency }}
                  </td>
                </tr>
                <tr>
                  <td>10.10</td>
                  <td>ER Other SSI - % of comp below level</td>
                  <td>
                    {{
                    calcData.employer_other.compensation_below_lvl
                    | numeral("0.2")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>10.11</td>
                  <td>ER Other SSI - compensation amount</td>
                  <td>
                    {{ calcData.employer_other.compensation_amount | currency }}
                  </td>
                </tr>
                <tr>
                  <td>10.12</td>
                  <td>ER Other SSI - % of comp above level</td>
                  <td>
                    {{
                    calcData.employer_other.compensation_above_lvl
                    | numeral("0.2")
                    }}%
                  </td>
                </tr>
                <tr>
                  <td>10.13</td>
                  <td>ER Other Funding Frequency</td>
                  <td>{{ calcData.employer_other.funding_frequency }}</td>
                </tr>
                <tr>
                  <td>10.14</td>
                  <td>er_other_contribution_ytd_dollars</td>
                  <!--<td>{{ calcData.employer_other. | currency }}</td>-->
                </tr>
                <tr>
                  <td
                      colspan="4"
                      scope="colgroup"
                      style="background-color: black; color:white"
                  >
                    NQDC Contributions
                  </td>
                </tr>
                <tr>
                  <td>11.01</td>
                  <td>nqdc_deferral_ytd</td>
                  <td>{{ calcData.nqdc.ytd_dollars | currency }}</td>
                </tr>
                <tr>
                  <td>11.02</td>
                  <td>nqdc_deferral_percent</td>
                  <td>{{ calcData.nqdc.percent | numeral("0.2") }}%</td>
                </tr>
                <tr>
                  <td>11.03</td>
                  <td>nqdc_deferral_dollars</td>
                  <td>{{ calcData.nqdc.dollars | currency }}</td>
                </tr>
                <tr>
                  <td>11.04</td>
                  <td>nqdc_deferral_dollars_frequency</td>
                  <td>{{ calcData.nqdc.dollars_frequency }}</td>
                </tr>

                <tr>
                  <td>11.05</td>
                  <td>nqdc_balance</td>
                  <td>{{ calcData.nqdc.balance | currency }}</td>
                </tr>
              </table>
            </md-content>
          </md-tab>
          <md-tab md-label="Payroll">
            <md-content class="md-padding" style="overflow:scroll">
              <table
                  style="text-align: center"
                  class="table table-striped table-bordered"
              >
                <tr style="background-color: green;">
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
                <tr>
                  <th>Normal<br> 402(g)<br> Limit</th>
                  <th>Normal<br>Catch-Up<br>Limit</th>
                  <th>Payroll<br>Date</th>
                  <th>Plan<br> Year<br> End</th>
                  <th>Beginning
                    Dollars
                    Pre-Tax</th>
                  <th>Normal
                    Contribution
                    Pre-Tax</th>
                  <th>Catchup
                    Contribution
                    Pre-Tax</th>
                  <th>Earnings
                    Pre-Tax</th>
                  <th>Ending
                    Balance
                    Pre-Tax</th>

                  <th>Beginning
                    Dollars
                    Roth</th>
                  <th>Normal
                    Contribution
                    Roth</th>
                  <th>Catchup
                    Contribution
                    Roth</th>
                  <th>Earnings
                    Roth</th>
                  <th>Ending
                    Balance
                    Roth</th>

                  <th>Beginning
                    Dollars
                    Post-Tax</th>
                  <th>Normal
                    Contribution
                    Post-Tax</th>
                  <th>Earnings
                    Post-Tax</th>
                  <th>Ending
                    Balance
                    Post-Tax</th>
                  <th>YTD Eligible
                    Contributions
                    in $</th>
                  <th>Eligible
                    Contributions
                    in $</th>
                  <th>Eligible
                    Contributions
                    in Percent</th>
                  <th>YTD Eligible
                    Compensation
                    in $</th>
                  <th>Quarter</th>
                  <th>YTD
                    ER Match
                    in $</th>
                  <th>QTD
                    ER Match
                    in $</th>
                  <th>MTD
                    ER Match
                    in $</th>
                  <th>Preliminary
                    Contribution
                    ER Matching</th>
                  <th> True-Up
                    Contribution </th>
                  <th> Final
                    Contribution
                    ER Matching </th>
                  <th>Beginning
                    Dollars
                    ER Matching</th>
                  <th> Funded
                    ER Match </th>
                  <th>Earnings
                    ER Matching</th>
                  <th>Ending
                  Balance
                  ER Matching</th>
                  <th>Years of
                    Service</th>
                  <th>YOS Days
                    Segment 1</th>
                  <th>YOS Days
                    Segment 2</th>
                  <th>YOS True-Up
                    Segment 1</th>
                  <th>YOS True-Up
                    Segment 1</th>
                </tr>
                <tr v-for="row in calcData.payroll.rows">
                  <td>{{row.normal_limit | currency }}</td>
                  <td>{{row.normal_catchup_limit | currency }}</td>
                  <td>
                    {{
                      row.date
                      | dateParse("YYYY-MM-DD")
                      | dateFormat("MM/D/YYYY")
                    }}
                  </td>
                  <td>
                    {{
                    row.plan_year_end
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("MM/D/YYYY")
                    }}
                  </td>
                  <td>{{row.pre_tax_beginning_balance | currency}}</td>
                  <td>{{row.pre_tax_normal_contribution | currency}}</td>
                  <td>{{row.pre_tax_catchup_contribution | currency}}</td>
                  <td>{{row.pre_tax_earning | currency}}</td>
                  <td>{{row.pre_tax_ending_balance | currency}}</td>

                  <td>{{row.roth_beginning_balance | currency}}</td>
                  <td>{{row.roth_normal_contribution | currency}}</td>
                  <td>{{row.roth_catchup_contribution | currency}}</td>
                  <td>{{row.roth_earning | currency}}</td>
                  <td>{{row.roth_ending_balance | currency}}</td>

                  <td>{{row.post_tax_beginning_balance | currency}}</td>
                  <td>{{row.post_tax_contribution | currency}}</td>
                  <td>{{row.post_tax_earning | currency}}</td>
                  <td>{{row.post_tax_ending_balance | currency}}</td>

                  <td>{{ row.ytd_eligible_contribution | currency }}</td>
                  <td>{{ row.eligible_contribution | currency }}</td>
                  <td>{{ row.percent_eligible_contribution | percentage }}</td>
                  <td>{{ row.ytd_eligible_compensation | currency }}</td>
                  <td>{{ row.quarter }}</td>
                  <td>{{ row.ytd_er_match | currency }}</td>
                  <td>{{ row.qtd_er_match | currency }}</td>
                  <td>{{ row.mtd_er_match | currency }}</td>
                  <td>{{ row.preliminary_contribution_er_match | currency }}</td>
                  <td>{{ row.true_up_contribution | currency }}</td>
                  <td>{{ row.final_contribution_er_match | currency }}</td>
                  <td>{{ row.beginning_dollars_er_match | currency }}</td>
                  <td>{{ row.funded_er_match | currency }}</td>
                  <td>{{ row.earning_er_match | currency }}</td>
                  <td>{{ row.ending_balance_er_match | currency }}</td>
                  <td>{{ row.yos | numeral("0.2") }}</td>
                  <td>{{ row.yos_days_segment1 | numeral("0.2") }}</td>
                  <td>{{ row.yos_days_segment2 | numeral("0.2") }}</td>
                  <td>{{ row.yos_true_up_segment1 | numeral("0.2") }}</td>
                  <td>{{ row.yos_true_up_segment2 | numeral("0.2") }}</td>
                </tr>
              </table>
            </md-content>
          </md-tab>

        </md-tabs>
      </md-content>
    </div>

  </div>
</template>
<style scoped src="bootstrap/dist/css/bootstrap.min.css"></style>

<script>
import RoeCalcInputFields from "@/components/calculators/InputFields";
import store from "@/store";
import { mapGetters } from "vuex";
import { CALC_CONTRIBUTION, CALC_RESET_STATE } from "@/store/actions.type";
import { INPUT_TYPES } from "@/store/calculatorInputs.type";
import "vue-material/dist/vue-material.css";
import "vue-material/dist/theme/default.css";
export default {
  data() {
    return {
      calcAction: CALC_CONTRIBUTION,
      inputCategories: [
        INPUT_TYPES.PARTICIPANT,
        INPUT_TYPES.PLAN_BASIC_DATA,
        INPUT_TYPES.AUTO_ENROLLMENT,
        INPUT_TYPES.AUTO_INCREASE,
        INPUT_TYPES.EMPLOYEE_CONTRIBUTION,
        INPUT_TYPES.EMPLOYEE_MATCH,
        INPUT_TYPES.EMPLOYEE_OTHER,
        INPUT_TYPES.PRE_TAX_CONTRIBUTION,
        INPUT_TYPES.ROTH_CONTRIBUTION,
        INPUT_TYPES.POST_TAX_CONTRIBUTION,
        INPUT_TYPES.NQDC_CONTRIBUTION,
        INPUT_TYPES.COMPLIANCE_LIMIT
      ]
    };
  },
  components: { RoeCalcInputFields },
  computed: {
    ...mapGetters(["calcData"])
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(CALC_RESET_STATE);
    return next();
  }
};
</script>
